import { getPasswordPolicies } from "../services/Management/PasswordAdministrationService";

const regexChecks = {
  hasUpperCase: (str) => {
    return /[A-Z]/.test(str);
  },
  hasLowerCase: (str) => {
    return /[a-z]/.test(str);
  },
  hasNumbers: (str) => {
    return /\d/.test(str);
  },
  hasSpecialCharacters: (str) => {
    return /[ !"#$£%&'()*+,-./:;<=>?@[\]^_`{|}~]/.test(str);
  },
  hasUnicode(str) {
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127) return true;
    }
    return false;
  },
};

class PasswordValidationRulesBuilder {
  constructor() {
    this.validationRules = [];
    this.passwordPolicies = {};
  }

  setPasswordPolicies() {
    return getPasswordPolicies();
  }

  setValidationRules(
    { oldPassword, newPassword, confirmNewPassword },
    userStatus,
    translations
  ) {
    if (
      this.passwordPolicies &&
      Object.keys(this.passwordPolicies).length > 0
    ) {
      this.clearValidationRules(
        {
          newPassword,
          confirmNewPassword,
        },
        translations
      );

      if (
        this.passwordPolicies.passwordLengthMin &&
        this.passwordPolicies.passwordLengthMax
      ) {
        this.validationRules.push({
          message: translations.BetweenChars(
            this.passwordPolicies.passwordLengthMin,
            this.passwordPolicies.passwordLengthMax
          ),
          validation:
            newPassword.length >= this.passwordPolicies.passwordLengthMin &&
            newPassword.length <= this.passwordPolicies.passwordLengthMax,
        });
      }

      if (
        this.passwordPolicies.characterPasswordPolicies &&
        this.passwordPolicies.characterPasswordPolicies.upperCaseAllowed
      ) {
        this.validationRules.push({
          message: translations.AtleastUppercase,
          validation: regexChecks.hasUpperCase(newPassword),
        });
      }

      if (
        this.passwordPolicies.characterPasswordPolicies &&
        this.passwordPolicies.characterPasswordPolicies.lowerCaseAllowed
      ) {
        this.validationRules.push({
          message: translations.AtleastLowercase,
          validation: regexChecks.hasLowerCase(newPassword),
        });
      }

      if (
        this.passwordPolicies.characterPasswordPolicies &&
        this.passwordPolicies.characterPasswordPolicies.base10DigitsAllowed
      ) {
        this.validationRules.push({
          message: translations.AtleastOneNum,
          validation: regexChecks.hasNumbers(newPassword),
        });
      }

      if (
        this.passwordPolicies.characterPasswordPolicies &&
        this.passwordPolicies.characterPasswordPolicies.specialCharactersAllowed
      ) {
        this.validationRules.push({
          message: translations.AtleastSpecialChar,
          validation: regexChecks.hasSpecialCharacters(newPassword),
        });
      }

      if (
        this.passwordPolicies.characterPasswordPolicies &&
        this.passwordPolicies.characterPasswordPolicies.unicodeCharactersAllowed
      ) {
        this.validationRules.push({
          message: translations.AtleastUnicodeChar,
          validation: regexChecks.hasSpecialCharacters(newPassword),
        });
      }

      if (userStatus !== undefined && userStatus !== "undefined") {
        if (userStatus === "0") {
          this.validationRules.push({
            message: translations.TempPasswordNotReused,
            validation:
              newPassword !== oldPassword &&
              newPassword !== "" &&
              oldPassword !== "",
          });
        } else if (userStatus === "2") {
          if (
            this.passwordPolicies.characterPasswordPolicies &&
            !this.passwordPolicies.characterPasswordPolicies
              .allowPasswordRepeatDuringExpiryReset
          ) {
            this.validationRules.push({
              message: translations.RepeatExpiredPasswordNotAllowed,
              validation:
                newPassword !== oldPassword &&
                newPassword !== "" &&
                oldPassword !== "",
            });
          }
        }
      }
    }
  }

  clearValidationRules({ newPassword, confirmNewPassword }, translations) {
    this.validationRules = [];

    this.validationRules.push({
      message: translations.BothPasswordsIdentical,
      validation:
        confirmNewPassword === newPassword &&
        confirmNewPassword !== "" &&
        newPassword !== "",
    });
  }
}

const instance = new PasswordValidationRulesBuilder();
export default instance;
